import { render, staticRenderFns } from "./IncomeClarify.vue?vue&type=template&id=d9d453b0&"
import script from "./IncomeClarify.vue?vue&type=script&lang=js&"
export * from "./IncomeClarify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports